import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { LoaderService } from './loader.service';
import { LoaderState } from './loader';

@Component({
    selector: 'angular-loader',
    // template: `<div [class.loader-hidden]="!show">
    //                 <div class="loader-overlay">
    //                         <div>
    //                             <mat-progress-bar color="warn" mode="indeterminate" *ngIf="show"></mat-progress-bar>
    //                         </div>
    //                 </div>
    //             </div>`,
    template: '',
    styles: [`.loader-hidden {
        visibility: hidden;
    }
    .loader-overlay {
        position: absolute;
        width:100%;
        top:0;
        left: 0;
        opacity: 1;
        z-index: 9999999999;
    }`],
})
export class LoaderComponent implements OnInit, OnDestroy {

    show = false;

    private subscription: Subscription;

    constructor(
        private loaderService: LoaderService
    ) { }

    ngOnInit() {
        this.subscription = this.loaderService.loaderState
            .subscribe((state: LoaderState) => {
                this.show = state.show;
            });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
